<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.asbName" style="width: 140px;" size="small" placeholder="请输入供应商名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.asbType" style="width: 140px;" size="small" placeholder="请输入分类"
                        clearable></el-input>
                    <el-input v-model="formDatas.asbProduct" style="width: 140px;" size="small" placeholder="请输入产品"
                        clearable></el-input>
                    <el-input v-model="formDatas.ascNumber" style="width: 140px;" size="small" placeholder="请输入合同编码"
                        clearable></el-input>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增供应商</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="asbId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑供应商' : '新增供应商'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: auto;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="供应商名称" prop="asbName">
                                <el-input v-model="form.asbName" style="width:80%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="分类" prop="asbType">
                                <el-input v-model="form.asbType" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="产品" prop="asbProduct">
                                <el-input v-model="form.asbProduct" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="产品图片" prop="asbProductImages">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr.sync="fileList" :limit="5"
                                    @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="联系人" prop="asbContacts">
                                <el-input v-model="form.asbContacts" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="职务" prop="asbPost">
                                <el-input v-model="form.asbPost" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="联系电话" prop="asbPhone">
                                <el-input v-model="form.asbPhone" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="最低起订量MOQ" prop="asbMqq">
                                <el-input v-model="form.asbMqq" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="价格" prop="asbPrice">
                                <el-input type="number" v-model="form.asbPrice" style="width:80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="供应商地址" prop="asbAddress">
                                <el-input v-model="form.asbAddress" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="首次合作时间" prop="asbDateFirst">
                                <el-date-picker v-model="form.asbDateFirst" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期" style="width:80%">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="合同编码" prop="ascNumber">
                                <el-input v-model="form.ascNumber" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="价格如何" prop="asbEvaluatePrice">
                                <el-radio-group v-model="form.asbEvaluatePrice">
                                    <el-radio label="高">高</el-radio>
                                    <el-radio label="中">中</el-radio>
                                    <el-radio label="低">低</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="品质如何" prop="asbEvaluateQuality">
                                <el-radio-group v-model="form.asbEvaluateQuality">
                                    <el-radio label="高">高</el-radio>
                                    <el-radio label="中">中</el-radio>
                                    <el-radio label="低">低</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="配合度如何" prop="asbEvaluateCoordinate">
                                <el-radio-group v-model="form.asbEvaluateCoordinate">
                                    <el-radio label="高">高</el-radio>
                                    <el-radio label="中">中</el-radio>
                                    <el-radio label="低">低</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="备注" prop="asbDes">
                                <el-input v-model="form.asbDes" style="width:80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
let Base64 = require('js-base64').Base64
var FileSaver = require('file-saver');
import { getAjSupplierBaseList, addAjSupplierBase, updateAjSupplierBase, deleteAjSupplierBase } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            fileList: [],
            key: 'asbId',
            dialog: false,
            edit: false,
            form: {
                asbName: '',
                asbType: '',
                asbProduct: '',
                asbProductImages: '',
                asbContacts: '',
                asbPost: '',
                asbPhone: '',
                asbMqq: '',
                asbPrice: '',
                asbAddress: '',
                asbDateFirst: '',
                ascNumber: '',
                asbEvaluatePrice: '',
                asbEvaluateQuality: '',
                asbEvaluateCoordinate: '',
                asbDes: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed:'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asbName",
                    key: "asbName",
                    title: "供应商",
                    align: "center",
                    fixed:'left',
                    width: 150,
                    edit: false,
                },
                {
                    field: "asbType",
                    key: "asbType",
                    title: "分类",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbProduct",
                    key: "asbProduct",
                    title: "产品",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbProductImages",
                    key: "asbProductImages",
                    title: "产品图片",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asbProductImages ? <el-image ref="scrImg" id="scrimg" src={row.asbProductImages.split(',')[0]} alt="" fit="fill" style="height: 80px;"
                                        previewSrcList={row.asbProductImages.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },
                },
                {
                    field: "asbContacts",
                    key: "asbContacts",
                    title: "联系人",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbPost",
                    key: "asbPost",
                    title: "职务",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbPhone",
                    key: "asbPhone",
                    title: "联系电话",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbMqq",
                    key: "asbMqq",
                    title: "最低起订量MOQ",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "asbPrice",
                    key: "asbPrice",
                    title: "价格",
                    align: "center",
                    edit: false,
                    width: 120,
                },
               
                {
                    field: "asbAddress",
                    key: "asbAddress",
                    title: "供应商地址",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                
                {
                    field: "asbDateFirst",
                    key: "asbDateFirst",
                    title: "首次合作时间",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "ascNumber",
                    key: "ascNumber",
                    title: "合同编码",
                    align: "center",
                    edit: false,
                    width: 250,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:60%;">
                                    {
                                        row.ascNumber ? 
                                           row.ascNumber
                                        : <span></span>
                                    }

                                </div>
                                <div style="width:40%;">
                                    {
                                        row.ascFile ? <el-button
                                            size="mini"
                                            type="text"
                                            on-click={() => this.Preview(row.ascFile)}
                                        >
                                            预览
                                        </el-button> : <span></span>
                                    }
                                    {row.ascFile ? 
                                        <el-button
                                            size="mini"
                                            type="text"
                                            on-click={() =>this.Download(row)}
                                        >
                                            下载
                                        </el-button>: <span></span>
                                    }
                                </div>
                                {/* <div style="margin-left:10px">
                                    <el-button size="mini" type="text" on-click={() => this.downloadFile('https://trainapp.aojuai.com/assets/excel/user.xlsx', '合同'))} > 编辑 </el-button>
                                </div> */}
                            </span>

                        );
                    },
                },
                {
                    field: "asbEvaluatePrice",
                    key: "asbEvaluatePrice",
                    title: "价格如何",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbEvaluateQuality",
                    key: "asbEvaluateQuality",
                    title: "品质如何",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbEvaluateCoordinate",
                    key: "asbEvaluateCoordinate",
                    title: "配合度如何",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asbDes",
                    key: "asbDes",
                    title: "备注",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed:'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                asbName: '',
                asbType: '',
                asbProduct: '',
                ascNumber: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Download(row) {
            this.openLoading()
            const suffix = row.ascNumber + '.' + row.ascFile.substring(row.ascFile.lastIndexOf('.') + 1)
            FileSaver.saveAs(row.ascFile, suffix)
            this.loadings.close()
        },
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        removeAfter(file) {
            const url = this.form.asbProductImages.findIndex(item => item === file)
            this.form.asbProductImages.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            console.log(this.form.asbProductImages, file);
            if (this.form.asbProductImages && this.form.asbProductImages.length > 0  ) {
                console.log(this.form.asbProductImages, file);
                this.form.asbProductImages.push(...file)
            } else {
                this.$set(this.form, 'asbProductImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjSupplierBase({ asbIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjSupplierBase({ asbIds: row.asbId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.asbProductImages = data.asbProductImages.split(',')
                console.log(this.form.asbProductImages);
                if (this.form.asbProductImages && this.form.asbProductImages.length > 0) {
                    this.form.asbProductImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })

                }

            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.asbProductImages = newForm.asbProductImages? newForm.asbProductImages.toString():''
                        addAjSupplierBase(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.asbProductImages = newForm.asbProductImages? newForm.asbProductImages.toString():''
                        updateAjSupplierBase(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.form = {
                asbName: '',
                asbType: '',
                asbProduct: '',
                asbProductImages: '',
                asbContacts: '',
                asbPost: '',
                asbPhone: '',
                asbMqq: '',
                asbPrice: '',
                asbAddress: '',
                asbDateFirst: '',
                ascNumber: '',
                asbEvaluatePrice: '',
                asbEvaluateQuality: '',
                asbEvaluateCoordinate: '',
                asbDes: '',
            }
            this.fileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.asbId = row.asbId
                    console.log(jsonObj);
                    updateAjSupplierBase(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjSupplierBaseList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjSupplierBaseList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjSupplierBaseList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>